import { Outlet, useLocation, useNavigate } from "react-router-dom";

const HiringCompanySettings: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <div className="flex flex-col flex-1 h-full rounded-lg bg-white w-full flex-grow p-6 overflow-hidden">
      <div className="border-b border-gray-200">
        <div className="flex space-x-32 text-xs px-48">
          <p
            onClick={() => navigate("/settings/account")}
            className={`cursor-pointer border-b-2 ${
              pathname.includes("/settings/account")
                ? "text-charcoal font-medium border-primary -mb-px"
                : "text-gray-500 hover:text-gray-700 border-white"
            } pb-4 px-1 `}
          >
            Account
          </p>
          <p
            onClick={() => navigate("/settings/company-details")}
            className={`cursor-pointer border-b-2 ${
              pathname.includes("/settings/company-details")
                ? "text-charcoal font-medium  border-primary -mb-px"
                : "text-gray-500 hover:text-gray-700 border-white"
            } pb-4 px-1`}
          >
            Company Details
          </p>
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default HiringCompanySettings;
